import { NON_CONSOLIDATED_WIRELESS_DEVICE_ID } from 'types/device-topology';
import { DeviceStatus, DeviceStatusCause } from 'types/device.enum';
import Device from 'types/models/device';
import SamplePoint, { BridgeDevice } from 'types/models/samplePoint';
import { getLatLongData } from 'utils/get-location';
import { isWirelessTrough } from 'utils/SamplePoints/trough';

import { patchBridgeDeviceStatus } from './patch-bridge-device-status';

export const computeBridgeDevice = (
  samplePoint: SamplePoint,
  hubDevice: Device | undefined
): BridgeDevice | undefined => {
  if (!hubDevice) {
    return undefined;
  }

  const loRaBatterySamplePoint = hubDevice.loraBatterySamplePoints.find((sp) =>
    sp.deviceTags.serialNumber === samplePoint.deviceTags.serialNumber
  );
  const loRaGpsSamplePoint = hubDevice.loraGpsSamplePoints.find((sp) =>
    sp.deviceTags.serialNumber === samplePoint.deviceTags.serialNumber
  );

  const hasBridgeDevice = loRaBatterySamplePoint || loRaGpsSamplePoint;
  if (!hasBridgeDevice) {
    return undefined;
  }

  const isXtendTroughFamily = isWirelessTrough(samplePoint);

  const bridgeDevice: BridgeDevice = {
    id: NON_CONSOLIDATED_WIRELESS_DEVICE_ID,
    name: samplePoint.name ?? '',
    status: samplePoint.status ?? DeviceStatus.UNKNOWN,
    statusCause: DeviceStatusCause.UNKNOWN,
    lastStatusDate: samplePoint.lastStatusDate ?? 0,
    serialNumber: `L-${samplePoint.deviceTags.serialNumber}`,
    batteryLevel: loRaBatterySamplePoint?.lastSampleData?.rwValue ?? null,
    location: loRaGpsSamplePoint
      ? getLatLongData(loRaGpsSamplePoint) ?? null
      : null
  };

  const lastSampleDate = samplePoint.lastSampleDate ?? 0;
  const { status, statusCause, lastStatusDate } = bridgeDevice;
  const patchedData = isXtendTroughFamily
    ? patchBridgeDeviceStatus({ status, statusCause, lastStatusDate, lastSampleDate })
    : undefined;

  return {
    ...bridgeDevice,
    status: patchedData?.status ?? status,
    statusCause: patchedData?.statusCause ?? statusCause,
    lastStatusDate: patchedData?.lastStatusDate ?? lastStatusDate
  };
};